import { render, staticRenderFns } from "./MemberContact.vue?vue&type=template&id=6cd95b54"
import script from "./MemberContact.vue?vue&type=script&lang=ts"
export * from "./MemberContact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports